import React from 'react';
import MyIssuesTable from './MyIssuesTable';
import { Issue } from '../headersegment/interfaces';

type ManageIssuesProps = {
  myIssues: Issue[];
};

const ManageIssues: React.FC<ManageIssuesProps> = ({ myIssues }) => (
  <>
    <div className="my-issues">
      <div className="row header">
        <div className="col-md-12 title">
          <table width="100%">
            <tbody>
              <tr>
                <td>My Issues</td>
                <td className="see-all">
                  <a href="/issues/my">See All</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      {myIssues.length > 0 ? (
        <MyIssuesTable issues={myIssues} />
      ) : (
        <div>
          <div className="row">
            <div className="col-md-12 none-found">No Issues Found</div>
          </div>
        </div>
      )}
    </div>
    <div className="row separator"></div>
  </>
);

export default ManageIssues;